import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode } from 'react';
import { Accept, FileRejection } from 'react-dropzone/.';
import { S_Dropzone } from '../../../../design/dropzone/S_Dropzone';
import { S_ClipLoader } from '../../../../design/loaders/clipLoader/S_ClipLoader';
import { FileList } from '../../../components/FileList';
import { IRejectedFile } from '../models/IRejectedFile';
import { RejectStatus } from '../models/RejectStatus';

library.add(faCheck);

interface IImageDropZoneProps {
  onFilesDrop: (files: File[], fileRejections: FileRejection[]) => void;
  acceptedFiles: File[];
  rejectedFiles: IRejectedFile[];
  isProcessingImages: boolean;
  acceptedFileTypes: Accept;
  disabled?: boolean;
}

interface IProps extends IImageDropZoneProps {
  children: ReactNode | ReactNode[];
}

export const ImagesDropZone = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const getRejectedDescription = (rejectedStatus: RejectStatus): string => {
    return t(rejectedStatus);
  };

  return (
    <>
      <S_Dropzone
        disabled={props.disabled}
        onDrop={props.onFilesDrop}
        accept={props.acceptedFileTypes}
      >
        {props.children}
      </S_Dropzone>
      {props.isProcessingImages && (
        <S_ClipLoader
          caption={t('processing_your_images')}
          color='#1F2046'
        />
      )}
      {(props.rejectedFiles.length > 0 || props.acceptedFiles.length > 0) && !props.isProcessingImages && (
        <div className='file-list-container'>
          <div className='valid'>
            <FontAwesomeIcon icon='check' /> <strong>{props.acceptedFiles.length}</strong> {t('files_ready_to_upload')}
          </div>
          <div className='invalid'>
            <FontAwesomeIcon icon='times' /> <strong>{props.rejectedFiles.length} </strong> {t('files_invalid')}
            {props.rejectedFiles.length > 0 && <span>:</span>}
          </div>
          <FileList
            items={props.rejectedFiles.map((f) => ({
              name: f.file.name,
              description: getRejectedDescription(f.status),
            }))}
          />
        </div>
      )}
    </>
  );
});
